import { render, staticRenderFns } from "./DeleteDeveloperWebhookModal.vue?vue&type=template&id=1f3f0146&lang=pug"
import script from "./DeleteDeveloperWebhookModal.vue?vue&type=script&lang=js"
export * from "./DeleteDeveloperWebhookModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports